import { useState, useCallback, useEffect } from "react";
import { apiCallsNetworkQuality } from "../api/calls/networkQuality";
import { apiCallsParking } from "../api/calls/parking";

export const useDeviceFilter = (filters, fetchFunction, deviceType, exportFunction, shouldFetch = true) => {
  const [devices, setDevices] = useState([]);
  const [gateways, setGateways] = useState([]);
  const [statsForGraph, setStatsForGraph] = useState([]);

  const [statusCounts, setStatusCounts] = useState({
    error: 0,
    off: 0,
    dim: 0,
    active: 0,
    selected: 0,
    deverror: 0,
    light: 0,
    gateway: 0,
    excellent: 0,
    good : 0,
    medium : 0,
    bad : 0,
    open : 0,
    close : 0,
    join : 0,
  });

  const searchDevices = useCallback(async (filters) => {
    try {
      const result = await fetchFunction(filters, deviceType);
      const devices = result.data;
      const counts = {
        error: 0,
        off: 0,
        dim: 0,
        active: 0,
        selected: 0,
        deverror: 0,
        light: 0,
        gateway: 0,
        excellent: 0,
        good : 0,
        medium : 0,
        bad : 0,
        open : 0,
        close : 0,
        join : 0,
      };

      if (devices.length !== 0){
        devices.map((device) => {
          const status = device.payload;
          counts[status]++;
        })
      }
      setDevices(devices);
      setStatusCounts(counts);
    } catch (err) {
      console.error("Error fetching devices:", err);
    }
  }, [fetchFunction]);

  const getStatsForGraph = async (filters) => {
    try {
      const result = await apiCallsParking.Actions.GetStatsForGraph(filters);
      setStatsForGraph(result);
    } catch (err) {
      console.error("Error fetching stats:", err);
      setStatsForGraph([]);
    }
  };

  useEffect(() => {
    if (deviceType !== "networkQuality")
      searchDevices(filters);
    if (deviceType === "networkQuality")
      loadGateways();
    if (deviceType === "parking")
      getStatsForGraph(filters);
  }, []);

  const handleSearchClick = () => {
    searchDevices(filters);
    getStatsForGraph(filters);
  };

  const exportDevices = () => {
    exportFunction(devices, filters);
  }

  const loadGateways = async () => {
    const result = await apiCallsNetworkQuality.Actions.LoadGateways();
    setGateways(result.data.data);
  }

  return { devices, statusCounts, searchDevices, handleSearchClick, exportDevices, gateways, statsForGraph};
};